// extracted by mini-css-extract-plugin
module.exports = {"section":"sticky-sidebar_section__SC8un","layout":"sticky-sidebar_layout__JRk1x","wrapper":"sticky-sidebar_wrapper__wRMDp"};